module.exports = "/_next/static/files/7b3e82b4cebcf7725cec3e2c3be34ee3.jpg";